<template>
  <div class="companies">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs :items="[{ text: $t('meta.sites'), name: 'company_sites' }, { text: $t('sites.addSite') }]" />
      </template>
      <template v-slot:meta>
        <Link :to="`/company/sites`" class="button button-grey button-small button-round">
          {{ $t('sites.allSites') }}
        </Link>
      </template>
    </SectionHeader>

    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <SiteForm @submit="createSite" />
      </div>
    </div>
  </div>
</template>

<script>
import SiteForm from '@/views/companies/sites/SiteForm'

import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import sitesApi from '@/api/sites'

export default {
  name: 'new_site',
  components: {
    BreadCrumbs,
    CompanyNav,
    SiteForm,
    SectionHeader,
  },
  methods: {
    async createSite(site) {
      const newSite = await sitesApi.create(site)
      if (newSite) {
        await this.$router.push(`/company/sites/${newSite.uuid}`)
      }
    },
  },
}
</script>
